import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { isValidFunction } from '../../../utils/nullChecks';
import { SwitchButtonProps } from '../types';
import Android12Switch from './Android12Switch';

const SwitchButton = (props: SwitchButtonProps) => {
    const {
        onChange,
        label,
        isAndroid12,
        ...otherProps
    } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log('switch-button-value', event.target.value);
        if (isValidFunction(onChange)) {
            onChange(event.target.checked, event);
        }
    };

    if (isAndroid12) {
        return (
            <FormControlLabel
                control={(
                    <Android12Switch
                        onChange={handleChange}
                        {...otherProps}
                    />
                )}
                label={label}
            />

        );
    }

    return (
        <FormControlLabel
            control={(
                <Switch
                    {...otherProps}
                    onChange={handleChange}
                />
            )}
            label={label}
        />
    );
};
SwitchButton.defaultProps = {
    isAndroid12: false,
};
export default SwitchButton;
